import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { BeneficiariesActions } from './beneficiaries.actions';

@Injectable({
  providedIn: 'root'
})
export class BeneficiariesEffects {
  sendBeneficiariesEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendBeneficiariesEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(BeneficiariesActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
